<template>
  <div>
    <h2>Prueba Drag & Drop Jerárquico</h2>
    <vue-draggable-tree v-model="treeData" @change="onTreeChange" />
    <pre>{{ JSON.stringify(treeData, null, 2) }}</pre>
  </div>
</template>

<script>
import VueDraggableTree from "vue-draggable-tree"; // Ahora usando la versión 1.x compatible con Vue 2
// import "vue-draggable-tree/dist/vue-draggable-tree.css"; // Si tienes el CSS, descomenta

export default {
  components: { VueDraggableTree },
  data() {
    return {
      treeData: [
        {
          key: "0",
          title: "女装",
          children: [
            {
              key: "0-1",
              title: "风衣",
            },
            {
              key: "0-2",
              title: "外套",
            },
          ],
        },
        {
          key: "1",
          title: "男装",
        },
        {
          key: "2",
          title: "图书",
          children: [
            {
              key: "2-0",
              title: "小说",
              children: [
                {
                  key: "2-0-0",
                  title: "九州牧云录",
                },
                {
                  key: "2-0-1",
                  title: "天空的城",
                },
                {
                  key: "2-0-2",
                  title: "三体",
                },
              ],
            },
            {
              key: "2-1",
              title: "经管",
              children: [
                {
                  key: "2-1-0",
                  title: "创京东",
                },
              ],
            },
            {
              key: "2-2",
              title: "科技",
              children: [
                {
                  key: "2-2-0",
                  title: "JavaScript权威指南",
                },
                {
                  key: "2-2-1",
                  title: "JavaScript高级程序设计",
                },
              ],
            },
          ],
        },
      ],
    };
  },
  methods: {
    onTreeChange(newTree) {
      this.treeData = newTree;
    },
  },
};
</script>

<style>
.vue-draggable-tree .tree-node {
  padding-left: 20px;
}
.vue-draggable-tree .tree-node-label {
  cursor: pointer;
}
</style>
